import PropTypes from 'prop-types';

import PropTypesPresenter from '../../utils/PropTypesPresenter';
import DatePresenter from '../../presenters/DatePresenter';
import { amountReadable } from '../../utils/functions';

const ADMIN_FEE = 'admin_fee';
const MEMBERSHIP_FEE = 'membership_fee';
const EXPIRED_FAST_CASH = 'expired_fast_cash';

export const TYPES = [ADMIN_FEE, MEMBERSHIP_FEE];

export default new PropTypesPresenter(
  {
    id: PropTypes.string,
    amount: PropTypes.number,
    meta: PropTypes.string,
    paymentType: PropTypes.string,
    state: PropTypes.string,
    createdAt: PropTypes.string,
    membershipId: PropTypes.string,
  },
  {
    createdAtReadable(payment) {
      const createdAt = this.createdAt(payment);
      return DatePresenter.shortFormattedDate(createdAt);
    },
    typeReadable(payment) {
      const typeMap = {
        [ADMIN_FEE]: 'Admin Fee',
        [MEMBERSHIP_FEE]: 'Membership Fee',
        [EXPIRED_FAST_CASH]: 'Expired FastCash',
      };
      const type = this.paymentType(payment);

      return typeMap[type];
    },
    amountReadable(payment) {
      const amount = this.amount(payment);

      return amountReadable(amount);
    },
  }
);
